module.exports = "---\ntitle: \"更换计数器\"\ntime: \"2025-2-21\"\n---\n\n由于Vercel的kv被刷爆了，以后都换成Cloudflare的worker计数，希望不会那么快炸\n";